// Start with verbs because it's actions : )
export const USER_LOGIN = "USER_LOGIN"
export const USER_LOGOUT = "USER_LOGOUT"
export const CHECK_AUTH = "CHECK_AUTH"
export const SUCCESSFULL_REGISTRATION = "SUCCESSFULL_REGISTRATION"
export const REGISTER_USER = "REGISTER_USER"
export const FETCH_PROFILE = "FETCH_PROFILE"
export const GET_USER_INFO = "GET_USER_INFO"
export const GET_USER_CONFIG = "GET_USER_CONFIG"
export const FORGET_PASSWORD = "FORGET_PASSWORD"
export const CHECK_USER_EXISTS = "CHECK_USER_EXISTS"
export const CHECK_USER_EMAIL_EXISTS = "CHECK_USER_EMAIL_EXISTS"
export const RESET_PASSWORD = "RESET_PASSWORD"
export const LOGIN_MARKETSMITHINDIA = "LOGIN_MARKETSMITHINDIA"
export const CALLBACK_REQUEST = "CALLBACK_REQUEST"
export const VERIFY_EMAIL = "VERIFY_EMAIL"
export const VALIDATE_REFERRALCODE = "VALIDATE_REFERRALCODE"
export const FIREBASE_CREATE_USER = "FIREBASE_CREATE_USER"
export const FIREBASE_SIGNIN_GOOGLE = "FIREBASE_SIGNIN_GOOGLE"
export const FIREBASE_SIGNIN_FACEBOOK = "FIREBASE_SIGNIN_FACEBOOK"
export const FIREBASE_SIGNIN_APPLE = "FIREBASE_SIGNIN_APPLE"
export const FIREBASE_SEND_FORGOT_PWD = "FIREBASE_SEND_FORGOT_PWD"
export const FIREBASE_VALIDATE_PHONE_NO = "FIREBASE_VALIDATE_PHONE_NO"
export const FIREBASE_VERIFY_PASSWORD_RESET = "FIREBASE_VERIFY_PASSWORD_RESET"
export const GET_PRODUCTS = "GET_PRODUCTS"
export const GET_RISK_TYPE = "GET_RISK_TYPE"
export const GET_RISK_PROFILER_INFO = "GET_RISK_PROFILER_INFO"
export const GET_DEFAULT_RISK_PROFILER = "GET_DEFAULT_RISK_PROFILER"
export const SAVE_RISK_PROFILER_INFO = "SAVE_RISK_PROFILER_INFO"
export const VALIDATE_PROMO = "VALIDATE_PROMO"
export const GENERATE_PAYU_HASH = "GENERATE_PAYU_HASH"
export const CREATE_PAYMENT_REQUEST = "CREATE_PAYMENT_REQUEST"
export const PROCESS_PAYMENT_REQUEST = "PROCESS_PAYMENT_REQUEST"
export const UPDATE_PAYMENT_REQUEST = "UPDATE_PAYMENT_REQUEST"
export const SEND_PAYMENT_FAILED_MAIL = "SEND_PAYMENT_FAILED_MAIL"
export const SEND_PAYMENT_SUCCESS_MAIL = "SEND_PAYMENT_SUCCESS_MAIL"
export const SEND_INITIAL_SUBSCRIPTION_MAIL = "SEND_INITIAL_SUBSCRIPTION_MAIL"
export const GET_USER_SUBSCRIPTION = "GET_USER_SUBSCRIPTION"
export const GET_USER_TRANSACTIONS = "GET_USER_TRANSACTIONS"
export const GENERATE_REPORT = 'GENERATE_REPORT'
export const PSI_LOGIN = 'PSI_LOGIN'
export const GENERATE_LAST_PORTFOLIO_INSIGHT = 'GENERATE_LAST_PORTFOLIO_INSIGHT'
export const AUTO_SUGGEST_SYMBOLS = "AUTO_SUGGEST_SYMBOLS"
export const DOWNLOAD_PDF = "DOWNLOAD_PDF"
export const GET_SYMBOL_PRICE = "GET_SYMBOL_PRICE"
export const GET_INSTRUMENT_ID = "GET_INSTRUMENT_ID"
export const GET_USER_REPORTS = "GET_USER_REPORTS"
export const POST_PDF_DOWNLOAD_SUCCESS = "POST_PDF_DOWNLOAD_SUCCESS"
export const UPDATE_POST_PDF_DOWNLOAD_SUCCESS = "UPDATE_POST_PDF_DOWNLOAD_SUCCESS"
export const UPDATE_SUBSCRIPTION = "UPDATE_SUBSCRIPTION"
export const GET_BROKER_USER_HOLDINGS = "GET_BROKER_USER_HOLDINGS"
export const GET_BROKER_ADMIN_USER_HOLDINGS = "GET_BROKER_ADMIN_USER_HOLDINGS"
export const SEND_RISK_PROFILER_MAIL_NOTIFICATION = "SEND_RISK_PROFILER_MAIL_NOTIFICATION"
export const GET_USER_BROKER_TOKEN = "GET_USER_BROKER_TOKEN"
export const GET_BROKER_ADMIN_TOKEN = "GET_BROKER_ADMIN_TOKEN"
export const CHECK_REGISTERED_BROKER_USER = "CHECK_REGISTERED_BROKER_USER"
export const SEND_REPORT_OVER_MAIL = "SEND_REPORT_OVER_MAIL"
export const GET_BROKER_SUBSCRIPTION = "GET_BROKER_SUBSCRIPTION"
export const GET_BROKER_ALL_LEADS = "GET_BROKER_ALL_LEADS"
export const GET_ALL_BROKER_PROMOTION = "GET_ALL_BROKER_PROMOTION"
export const EDIT_BROKER_PROMOTION = "EDIT_BROKER_PROMOTION"
export const GET_BROKER_PRODUCT = "GET_BROKER_PRODUCT"
export const UPSERT_BROKER_PROMOTION = "UPSERT_BROKER_PROMOTION"
export const CHECK_USER_CKYC = "CHECK_USER_CKYC"
export const GET_LEGAL_AGREEMENT = "GET_LEGAL_AGREEMENT"
export const SAVE_LEGAL_AGREEMENT = "SAVE_LEGAL_AGREEMENT"
export const GET_USER_LAST_REPORT = "GET_USER_LAST_REPORT"
export const GET_ACTIVE_MSI_PORTFOLIO = "GET_ACTIVE_MSI_PORTFOLIO"
export const GET_MS_TRANSACTION_HISTORY = "GET_MS_TRANSACTION_HISTORY"
export const UPDATE_MSI_REPORT_SUBSCRIPTION = "UPDATE_MSI_REPORT_SUBSCRIPTION"
export const VALIDATE_HOLIDAY_DATE = "VALIDATE_HOLIDAY_DATE"
export const CREATE_RZP_PAYMENT_REQUEST = "CREATE_RZP_PAYMENT_REQUEST"
export const PROCESS_RZP_PAYMENT_REQUEST = "PROCESS_RZP_PAYMENT_REQUEST"
export const STANDARD_CHARTEREDDATA_GENERATE_REPORT = "STANDARD_CHARTEREDDATA_GENERATE_REPORT"






// WEBPACK FOOTER //
// ./src/store/actions.type.js